module.exports = __webpack_public_path__ + "media/identify/icon_fourth-bf9e0c48.svg";